// extracted by mini-css-extract-plugin
export default {"promptModalBody":"styles_promptModalBody__CPdxQ","button":"styles_button__A4J+O"};